export const config = {
    baseUrl : '/api'
}
